import React, { memo } from 'react';
import { FaClock, FaArrowRight } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const BlogCard = memo(({ post }) => {
  return (
    <Link to={`/blog/${post.slug}`} className="group block h-full">
      <article className="flex flex-col h-full overflow-hidden rounded-2xl bg-white dark:bg-gray-800 border border-gray-100 dark:border-gray-700 hover:border-gray-300 dark:hover:border-gray-600 transition-all duration-300 hover:-translate-y-1 hover:shadow-lg">
        {/* Image */}
        <div className="relative aspect-[16/9] overflow-hidden bg-gray-100 dark:bg-gray-700">
          {post.image ? (
            <img
              src={post.image}
              alt={post.title}
              loading="lazy"
              decoding="async"
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-gray-200 to-gray-300 dark:from-gray-700 dark:to-gray-600">
              <span className="text-4xl font-bold text-gray-400 dark:text-gray-500">
                {post.title.charAt(0)}
              </span>
            </div>
          )}
        </div>

        {/* Content */}
        <div className="flex flex-col flex-1 p-4 sm:p-5 md:p-6">
          {/* Category & Reading Time */}
          <div className="flex items-center gap-3 mb-2 sm:mb-3">
            <span className="text-sm font-medium text-emerald-600 dark:text-emerald-400">
              {post.category}
            </span>
            <span className="w-1 h-1 rounded-full bg-gray-300 dark:bg-gray-600" />
            <span className="flex items-center gap-1 text-sm text-gray-500 dark:text-gray-400">
              <FaClock className="w-3 h-3" />
              {post.readTime} min
            </span>
          </div>

          {/* Title */}
          <h3 className="text-lg sm:text-xl font-bold text-gray-900 dark:text-white mb-2 group-hover:text-emerald-600 dark:group-hover:text-emerald-400 transition-colors line-clamp-2">
            {post.title}
          </h3>

          {/* Excerpt */}
          <p className="text-sm sm:text-base text-gray-600 dark:text-gray-400 line-clamp-2 mb-3 sm:mb-4 flex-1">
            {post.excerpt}
          </p>

          {/* Author & Date */}
          <div className="flex items-center justify-between pt-3 sm:pt-4 border-t border-gray-100 dark:border-gray-700">
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 rounded-full bg-gradient-to-br from-gray-200 to-gray-300 dark:from-gray-700 dark:to-gray-600 flex items-center justify-center text-sm font-semibold text-gray-600 dark:text-gray-300">
                {post.author.charAt(0)}
              </div>
              <div>
                <div className="text-sm font-medium text-gray-900 dark:text-white">
                  {post.author}
                </div>
                <div className="text-sm text-gray-500 dark:text-gray-400">
                  {post.date}
                </div>
              </div>
            </div>

            <span className="text-emerald-600 dark:text-emerald-400 group-hover:translate-x-1 transition-transform">
              <FaArrowRight className="w-4 h-4" />
            </span>
          </div>
        </div>
      </article>
    </Link>
  );
});

BlogCard.displayName = 'BlogCard';

export default BlogCard;